// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProductPage_overlay__4cqKA {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 9999;
}

.EditProductPage_card__6VEiu {
  width: 300px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(0,0,0,0.22);
  overflow: hidden;
  border: 1px solid rgba(29,135,82,0.18);
}

.EditProductPage_header__EhlUn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(29,135,82,0.18);
  background: rgba(232, 243, 237, 1);
}

.EditProductPage_title__WlaGv {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: rgba(29,135,82,1);
}

.EditProductPage_iconBtn__NYUFO {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
}

.EditProductPage_iconBtn__NYUFO:hover {
  background: rgba(29,135,82,0.10);
}

.EditProductPage_label__X06pF {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px 0 16px;
  font-size: 13px;
  color: #2a2a2a;
}

.EditProductPage_inputWrap__lq4FC { position: relative; }

.EditProductPage_input__Xf1w1 {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  border: 1px solid #d8d8d8;
  padding: 0 42px 0 12px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.EditProductPage_input__Xf1w1:focus {
  border-color: rgba(29,135,82,1);
  box-shadow: 0 0 0 2px rgba(29,135,82,0.15);
}

.EditProductPage_clearBtn__VSfDd {
    text-align: center;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: rgba(29,135,82,0.10);
  color: rgba(29,135,82,1);
  font-size: 18px;
  line-height: 1;
}

.EditProductPage_clearBtn__VSfDd:hover { background: rgba(29,135,82,0.16); }

.EditProductPage_fastRow__aPk7Y {
  margin: 12px 16px 0 16px;
  padding: 12px;
  border: 1px solid rgba(29,135,82,0.35);
  border-radius: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}

.EditProductPage_btnPrimary__ujoqk {
  padding-left: 12px;
  margin: 14px 16px 0 16px;
  width: calc(100% - 44px);
  height: 44px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  background: rgba(29,135,82,1);
  color: #fff;
}

.EditProductPage_btnPrimary__ujoqk:hover { background: rgba(24,115,70,1); }

.EditProductPage_btnPrimary__ujoqk:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.EditProductPage_btnSecondary__ouONV {
  padding-left: 12px;

  margin: 10px 16px 16px 16px;
  width: calc(100% - 44px);
  height: 44px;
  border-radius: 10px;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  font-weight: 600;
  background: #fff;
}

.EditProductPage_btnSecondary__ouONV:hover { background: #f7f7f7; }

.EditProductPage_emptyText__-8Spf {
  padding: 18px 16px;
  color: #444;
  font-size: 14px;
}

/* ✅ ЧЕКБОКС СТРОКА (как на твоей картинке, но зелёный) */
.EditProductPage_fastRow__aPk7Y {
  margin: 12px 16px 0 16px;
  padding: 12px;
  border: 1px solid rgba(29,135,82,0.35);
  border-radius: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
  background: #fff;
}

.EditProductPage_fastText__SIg10 {
  font-weight: 600;
  color: #111;
}

/* ✅ кастомный чекбокс */
.EditProductPage_checkbox__Ggvco {
  position: relative;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}

.EditProductPage_checkbox__Ggvco input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.EditProductPage_customCheckbox__amw\\+R {
  position: absolute;
  inset: 0;
  background: #fff;
  border: 2px solid rgba(29,135,82,1);
  border-radius: 4px;
  transition: 0.2s ease;
}

.EditProductPage_checkbox__Ggvco input:checked + .EditProductPage_customCheckbox__amw\\+R {
  background: rgba(29,135,82,1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}

.EditProductPage_checkbox__Ggvco input:focus-visible + .EditProductPage_customCheckbox__amw\\+R {
  box-shadow: 0 0 0 3px rgba(29,135,82,0.22);
}



`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/EditProductPage.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA,oCAAa,kBAAkB,EAAE;;AAEjC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;IACI,kBAAkB;EACpB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA,yCAAkB,gCAAgC,EAAE;;AAEpD;EACE,wBAAwB;EACxB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;AACb;;AAEA,2CAAoB,6BAA6B,EAAE;;AAEnD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6CAAsB,mBAAmB,EAAE;;AAE3C;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,wBAAwB;EACxB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  z-index: 9999;\n}\n\n.card {\n  width: 300px;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 16px 40px rgba(0,0,0,0.22);\n  overflow: hidden;\n  border: 1px solid rgba(29,135,82,0.18);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(29,135,82,0.18);\n  background: rgba(232, 243, 237, 1);\n}\n\n.title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: rgba(29,135,82,1);\n}\n\n.iconBtn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n}\n\n.iconBtn:hover {\n  background: rgba(29,135,82,0.10);\n}\n\n.label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 16px 0 16px;\n  font-size: 13px;\n  color: #2a2a2a;\n}\n\n.inputWrap { position: relative; }\n\n.input {\n  width: 100%;\n  height: 42px;\n  border-radius: 10px;\n  border: 1px solid #d8d8d8;\n  padding: 0 42px 0 12px;\n  font-size: 14px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.input:focus {\n  border-color: rgba(29,135,82,1);\n  box-shadow: 0 0 0 2px rgba(29,135,82,0.15);\n}\n\n.clearBtn {\n    text-align: center;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: rgba(29,135,82,0.10);\n  color: rgba(29,135,82,1);\n  font-size: 18px;\n  line-height: 1;\n}\n\n.clearBtn:hover { background: rgba(29,135,82,0.16); }\n\n.fastRow {\n  margin: 12px 16px 0 16px;\n  padding: 12px;\n  border: 1px solid rgba(29,135,82,0.35);\n  border-radius: 10px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-size: 14px;\n}\n\n.btnPrimary {\n  padding-left: 12px;\n  margin: 14px 16px 0 16px;\n  width: calc(100% - 44px);\n  height: 44px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-weight: 700;\n  background: rgba(29,135,82,1);\n  color: #fff;\n}\n\n.btnPrimary:hover { background: rgba(24,115,70,1); }\n\n.btnPrimary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btnSecondary {\n  padding-left: 12px;\n\n  margin: 10px 16px 16px 16px;\n  width: calc(100% - 44px);\n  height: 44px;\n  border-radius: 10px;\n  border: 1px solid #d8d8d8;\n  cursor: pointer;\n  font-weight: 600;\n  background: #fff;\n}\n\n.btnSecondary:hover { background: #f7f7f7; }\n\n.emptyText {\n  padding: 18px 16px;\n  color: #444;\n  font-size: 14px;\n}\n\n/* ✅ ЧЕКБОКС СТРОКА (как на твоей картинке, но зелёный) */\n.fastRow {\n  margin: 12px 16px 0 16px;\n  padding: 12px;\n  border: 1px solid rgba(29,135,82,0.35);\n  border-radius: 10px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-size: 14px;\n  background: #fff;\n}\n\n.fastText {\n  font-weight: 600;\n  color: #111;\n}\n\n/* ✅ кастомный чекбокс */\n.checkbox {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n}\n\n.checkbox input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.customCheckbox {\n  position: absolute;\n  inset: 0;\n  background: #fff;\n  border: 2px solid rgba(29,135,82,1);\n  border-radius: 4px;\n  transition: 0.2s ease;\n}\n\n.checkbox input:checked + .customCheckbox {\n  background: rgba(29,135,82,1);\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.checkbox input:focus-visible + .customCheckbox {\n  box-shadow: 0 0 0 3px rgba(29,135,82,0.22);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `EditProductPage_overlay__4cqKA`,
	"card": `EditProductPage_card__6VEiu`,
	"header": `EditProductPage_header__EhlUn`,
	"title": `EditProductPage_title__WlaGv`,
	"iconBtn": `EditProductPage_iconBtn__NYUFO`,
	"label": `EditProductPage_label__X06pF`,
	"inputWrap": `EditProductPage_inputWrap__lq4FC`,
	"input": `EditProductPage_input__Xf1w1`,
	"clearBtn": `EditProductPage_clearBtn__VSfDd`,
	"fastRow": `EditProductPage_fastRow__aPk7Y`,
	"btnPrimary": `EditProductPage_btnPrimary__ujoqk`,
	"btnSecondary": `EditProductPage_btnSecondary__ouONV`,
	"emptyText": `EditProductPage_emptyText__-8Spf`,
	"fastText": `EditProductPage_fastText__SIg10`,
	"checkbox": `EditProductPage_checkbox__Ggvco`,
	"customCheckbox": `EditProductPage_customCheckbox__amw+R`
};
export default ___CSS_LOADER_EXPORT___;
